import './../scss/styles.scss';

import './lib/templates.js';
import './lib/main.js';
import $ from "jquery";
import {openModal} from "./lib/modals";

export function showLoginModal() {
    $('.overlay').hide();
    openModal('log-in-modal');
}


export function showLoggedInModal() {
    $('.overlay').hide();
    openModal('logged-in-modal');
}
